import store from "CommonState/store";
import {
  Component,
} from "react";
import Confirmation from "CommonComponents/confirmation";
import {
  ANTRAGSTELLERMODUS,
  ASTMODUSKEY,
} from "App/constants";

@store("flag_antragstellermodus")
export default class AntragDruckenPopup extends Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    const { onCancel, onConfirm, flag_antragstellermodus } = this.props;
    const { errorMessage } = this.state;

    const modus = ANTRAGSTELLERMODUS[flag_antragstellermodus];
    const istTarif = modus.value == ASTMODUSKEY.Tarif;

    return (
      <Confirmation
        header={`${ istTarif ? "Anlagen zum " : "" }${ modus.labelVertrag } drucken`}
        action='Zu Anlagen wechseln'
        actionStyle='primary'
        onCancel={onCancel}
        onConfirm={onConfirm}
        errorMessage={errorMessage}
      >
        {!istTarif && <p>Der {modus.labelVertrag} muss in 2facher Ausfertigung vorgelegt werden; abhängig von dem Vertragsverhältnis sind darüber hinaus weitere Unterlagen in Papierform dem Personaldezernat vorzulegen.</p>}
        <p>Welche Unterlagen Sie genau einreichen müssen, wird Ihnen in diesem Antrag unter "Anlagen" angezeigt.</p>
        <br />
      </Confirmation>
    );
  }
}
